<template>
  <div class="productdetails">
    <headerBar title="订单详情" homeshow="0"></headerBar>
    <!-- 进度信息 -->
    <div class="header">
      <ul>
        <li>
            <!-- -1待付款 0已付款 1待发货 2已发货 3已确认 -->
          <img src="../../static/images/jindu.png" alt />
          <p>下单</p>
          <span></span>
        </li>
        <li>
          <img src="../../static/images/jindu.png" alt :class="order_info.status < 0 ? 'no' : ''"/>
          <p>付款</p>
          <span></span>
        </li>
        <li>
          <img src="../../static/images/jindu.png" alt :class="order_info.status < 1 ? 'no' : ''"/>
          <p>配货</p>
          <span></span>
        </li>
        <li>
          <img src="../../static/images/jindu.png" alt :class="order_info.status < 2? 'no' : ''" />
          <p>发货</p>
          <span></span>
        </li>
        <li>
          <img src="../../static/images/jindu.png" alt :class="order_info.status < 3 ? 'no' : ''" />
          <p>完成</p>
        </li>
      </ul>
    </div>
    <!-- 进度信息 end -->
    <div class="content">
      <!-- 快递信息 start -->
      <div class="address">
        <div class="addressimg">
          <img src="../../static/images/address.png" alt />
        </div>
        <div class="addressmsg">
          <div class="name">
            <div class="truename">姓名：{{order_info.name}}</div>
            <div class="truephone">手机：{{order_info.mobile}}</div>
          </div>
          <div class="sweepmsg">{{order_info.address}}</div>
        </div>
      </div>
      <!-- 快递信息 end -->
      <div class="ordernum">
        <p class="ordertitle">订单信息</p>
        <ul>
          <li>
            <p>订单编号：</p>
            <span>{{order_info.order_sn}}</span>
          </li>
          <li>
             <p>商品名称：</p>
            <span>{{order_info.good_name}}</span>
          </li>
          <li>
             <p>申请数量：</p>
            <span>{{order_info.num}}</span>
          </li>
          
          <li v-show="order_info.express_type">
            <p>快递公司：</p>
            <span>{{order_info.express_type}}</span>
          </li>
          <li v-show="order_info.express_number">
            <p>快递单号：</p>
            <span>{{order_info.express_number}}</span>
          </li>
          <li>
            <p>商品价格：</p>
            <span>￥{{order_info.money-order_info.postage}}</span>
          </li>
          <li>
            <p>订单运费：</p>
            <span>￥{{order_info.postage}}</span>
          </li>
          <li v-show="order_info.pay_time">
            <p>支付时间：</p>
            <span>{{order_info.pay_time}}</span>
          </li>
          <li>
            <p>创建时间：</p>
            <span>{{order_info.create_time}}</span>
          </li>
          <li class="money">
            <p>订单总价：</p>
            <span>￥{{order_info.money}}</span>
          </li>
        </ul>
      </div>
      <!-- 订单信息 end -->
    </div>
    <!-- content end -->

    <div class="button">
      <button class="apply" @click="gotoapply(order_info.id)" v-if="order_info.status == -1">去付款</button>
      <button class="confirm"  @click="confirm(order_info.id)" v-if="order_info.status == 2">确认收货</button>
    </div>
  </div>
</template>

<script>
import { Toast, MessageBox } from "mint-ui";
export default {
  data() {
    return {
      order_id: 0,
      order_info: []
    };
  },
  mounted() {
    if (
      !window.localStorage.getItem("is_check_login") ||
      window.localStorage.getItem("is_check_login") == 0
    ) {
      this.$router.push("/login");
    }
    this.order_id = this.$route.query.order_id || 0;
    if (this.order_id) {
      this.getInfo();
    } else {
      this.$router.push("/applyforrecord");
    }
  },
  methods: {
    //前往付款
    gotoapply(id) {
      this.$router.push("cashier?order_id=" + id);
    },
    //确认收货
    confirm(order_id) {
      MessageBox.confirm("确认收货吗？", "提示").then(action => {
        this.$request.get(
          "/front/signOrder/orderConfirm",
          { order_id: order_id },
          res => {
            if (res.status == 1) {
              window.location.reload();
            } else {
              Toast(res.msg);
            }
          }
        );
      });
    },
    getInfo() {
      this.$request.get(
        "/front/signOrder/order",
        { order_id: this.order_id },
        res => {
          console.log(res);
          if (res.status == 1) {
            this.order_info = res.result;
          } else {
            this.$router.push("applyforrecord");
          }
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.button {
  position: fixed;
  bottom: 0px;
  right: 0px;
  left: 0px;
  height: 1rem;
  background-color: #ffffff;
  text-align: right;
  button {
    margin: 0.3rem 0.2rem 0.01rem 0rem;
    padding: 0.01rem 0.2rem;
    border-radius: 15px;
    border: 1px solid;
  }
  .details {
    color: #000000;
  }
  .apply {
    color: #a12e2e;
  }
  .confirm {
    color: #00b378;
  }
}
.productdetails {
  headerBar {
    height: 0.8rem;
  }
  .header {
    width: 100%;
    height: 1rem;
    margin-top: 0.8rem;
    background: #299e72;
    ul {
      width: 100%;
      height: 1.4rem;
      margin: 0.5rem;
      color: #ffffff;
      li {
        width: 20%;
        height: 100%;
        float: left;
        position: relative;
        span {
          width: 1.13rem;
          height: 2px;
          background: #ffffff;
          position: absolute;
          right: -0.1rem;
          top: 0.23rem;
        }
        img {
          width: 0.3rem;
          height: 0.3rem;
          // background: #ffffff;
          border-radius: 50px;
          color: #00b378;
          margin-left: 0.13rem;
        }
        img.no {
          background: #ffffff;
        }
      }
    }
  }
  .content {
    margin: 0 0.2rem;
    .ordernum {
      font-size: 0.26rem;
      background: #ffffff;
      margin-top: 0.2rem;
      padding: 0.2rem;
      border-radius: 5px;
      .ordertitle {
        font-size: 0.3rem;
        padding: 0.1rem 0;
        font-weight: bold;
      }
      ul {
        li {
          display: flex;
          font-size: 0.28rem;
          line-height: 0.4rem;
          padding: 0.05rem 0;
        }
        .money {
          padding-top: 0.2rem;
          font-size: 0.3rem;
          display: flex;
          justify-content: space-between;
          span {
            color: #ff7e00;
          }
        }
      }
    }
    .address {
      display: flex;
      background: #fff;
      padding: 0.2rem;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      font-size: 0.28rem;
      .addressimg {
        img {
          width: 0.5rem;
          height: 0.5rem;
          margin: 0.3rem auto;
        }
        padding-right: 0.2rem;
      }
      .addressmsg {
        .name {
          display: flex;
          color: #504f4f;
          .truephone {
            padding-left: 0.2rem;
          }
        }
        .sweepmsg {
          color: #2c2929;
          padding-top: 0.2rem;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/productdetails.vue